import React, { useContext, useRef } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, FormControl, Button } from "@material-ui/core";
import ImageGallery from "react-image-gallery";
import {
  ChevronLeft,
  ChevronRight,
  AttachmentRounded,
} from "@material-ui/icons";
import { useSnackbar } from "notistack";
import { LangContext } from "../../context/lang";
import { uploadFile } from "../../apis/other";
import { DesignContext } from "../../context/design";

const useStyles = makeStyles((theme: Theme) => ({
  gallary: {
    padding: theme.spacing(1),
  },
  attachIcon: {
    marginLeft: theme.spacing(0.5),
  },
  gridDel: {
    display: "flex",
    justifyContent: "flex-end",
  },
  btnDel: {
    textTransform: "unset",
    color: theme.palette.common.white,
    background: theme.palette.error.main,
    "&:hover": {
      background: theme.palette.error.dark,
    },
  },
}));

const EquipDesignImages = () => {
  const classes = useStyles();
  const imageGallaryRef = useRef(null);
  const { lang } = useContext(LangContext);
  const { map, event, setevent } = useContext(DesignContext);
  const { feature } = event;
  const { enqueueSnackbar } = useSnackbar();

  const uploadImages = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files;
    const file = files?.item(0);
    console.log(file);
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);

    if (file) {
      const formData = new FormData();
      formData.append("file", file, file.name);
      const rsUploadFile = await uploadFile(formData);
      if (rsUploadFile.status === 200) {
        const pathFile =
          process.env.NODE_ENV === "production"
            ? `${process.env.REACT_APP_REANDER_UPLOAD_FILE}${rsUploadFile.data.data[0].file}`
            : rsUploadFile.data.data[0].file;
        if (feature?.properties?.images) {
          draw.setFeatureProperty(feature?.id, "images", [
            ...feature?.properties.images,
            pathFile,
          ]);
          setevent({
            ...event,
            feature: {
              ...feature,
              properties: {
                ...feature?.properties,
                images: [...feature?.properties.images, pathFile],
              },
            },
          });
        } else {
          draw.setFeatureProperty(feature?.id, "images", [pathFile]);
          setevent({
            ...event,
            feature: {
              ...feature,
              properties: {
                ...feature?.properties,
                images: [pathFile],
              },
            },
          });
        }
      } else {
        enqueueSnackbar(`Error ${rsUploadFile.statusText}`, {
          variant: "error",
        });
      }
    }
  };

  const deleteImage = () => {
    const imageGallary: any = imageGallaryRef.current;
    let mapEvent: any = map;
    const draw = mapEvent._controls.find((control: any) => control.modes);
    const newImages = feature?.properties?.images.filter(
      (image: string, index: number) => index !== imageGallary.getCurrentIndex()
    );
    draw.setFeatureProperty(feature?.id, "images", newImages);
    setevent({
      ...event,
      feature: {
        ...feature,
        properties: {
          ...feature?.properties,
          images: newImages,
        },
      },
    });
  };

  return (
    <Grid item xs={12}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="subtitle1">{lang.data.images}</Typography>
        </Grid>
        <Grid item xs={12} className={classes.gallary}>
          {feature?.properties?.images &&
            feature?.properties?.images.length > 0 && (
              <ImageGallery
                ref={imageGallaryRef}
                renderLeftNav={(onClick: any, disabled: boolean) => (
                  <button
                    className="image-gallery-icon image-gallery-left-nav"
                    disabled={disabled}
                    onClick={onClick}
                  >
                    <ChevronLeft />
                  </button>
                )}
                renderRightNav={(onClick: any, disabled: boolean) => (
                  <button
                    className="image-gallery-icon image-gallery-right-nav"
                    disabled={disabled}
                    onClick={onClick}
                  >
                    <ChevronRight />
                  </button>
                )}
                items={feature.properties.images.map((image: string) => ({
                  original: image,
                }))}
                lazyLoad={true}
                showPlayButton={false}
                showFullscreenButton={false}
                showThumbnails={false}
                showBullets={Boolean(
                  feature?.properties?.images &&
                    feature?.properties?.images.length > 0
                )}
              />
            )}
        </Grid>
        <Grid item xs={6}>
          <FormControl>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="btn-upload-image"
              type="file"
              multiple={false}
              onChange={uploadImages}
            />
            <label htmlFor="btn-upload-image">
              <Button
                variant="contained"
                color="secondary"
                component="span"
                style={{ textTransform: "unset" }}
              >
                {lang.data.chooseImage}
                <AttachmentRounded
                  fontSize="small"
                  className={classes.attachIcon}
                />
              </Button>
            </label>
          </FormControl>
        </Grid>
        {Boolean(
          feature?.properties?.images && feature?.properties?.images.length > 0
        ) && (
          <Grid item xs={6} className={classes.gridDel}>
            <Button
              variant="contained"
              className={classes.btnDel}
              onClick={deleteImage}
            >
              Delete Image
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default EquipDesignImages;
